/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { Loading } from '@guillotinaweb/react-gmi'
import {
  RedoOutlined,
  FileSearchOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import { Table, Tabs, Select, Button, message, Affix } from 'antd'

import PriceComparatorTable from '../../components/price-comparator-table'
import { ALL_COUNTRIES, COUNTRIES } from '../../consts'
import { ErpClientContext } from '../../services/erp'
import { ProductSelector } from '../../components/product-selector'

const { TabPane } = Tabs

export function AnalyticsPage() {
  return (
    <div
      className="column is-10"
      style={{ backgroundColor: '#fff', padding: '30px', width: '100%' }}
    >
      <div className="level">
        <div className="level-left">
          <h2 className="title is-size-4">Analytics</h2>
        </div>
      </div>

      <Tabs defaultActiveKey="1">
        <TabPane tab="Product traffic & performance" key="1">
          <ProductTrafficAndPerformance />
        </TabPane>
        <TabPane tab="Funnel" key="2">
          <Funnel />
        </TabPane>
        <TabPane tab="Price comparator" key="3">
          <PriceComparator />
        </TabPane>
      </Tabs>
    </div>
  )
}

function ProductTrafficAndPerformance() {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const erpService = useContext(ErpClientContext)

  const dataToFilter = {
    grupo: [...new Set(data?.map?.((item) => item.grupo))],
    domain: [...new Set(data?.map?.((item) => item.domain))],
  }

  useEffect(() => {
    async function init() {
      setLoading(true)
      setError(null)
      try {
        setData(await erpService.getAnalytics())
        setLoading(false)
      } catch (e) {
        setError(e)
        setLoading(false)
      }
    }
    init()
  }, [])

  const columns = [
    'grupo',
    'domain',
    'unique_users',
    'add_to_cart',
    'add_to_cart_percent',
    'purchase',
    'purchase_percent',
  ].map((key) => {
    let column = {
      title: key,
      dataIndex: key,
      key,
      sorter: (a, b) => {
        if (a[key] < b[key]) return -1
        if (a[key] > b[key]) return 1
        return 0
      },
    }

    if (dataToFilter[key]) {
      column = {
        ...column,
        filters: dataToFilter[key].map((value) => ({ text: value, value })),
        filterMode: 'tree',
        filterSearch: true,
        onFilter: (value, record) => record[key].includes(value),
      }
    }

    return column
  })

  return (
    <div>
      {loading && <Loading />}
      {error && <div>{error.message}</div>}
      {data && <Table dataSource={data} columns={columns} pagination={false} />}
    </div>
  )
}

function Funnel() {
  return (
    <div>
      <i>Under construction</i>
    </div>
  )
}

function PriceComparator() {
  const [urls, setUrls] = useState()
  const [rest, setRest] = useState()
  const [page, setPage] = useState(0)
  const [prod, setProd] = useState()
  const [loading, setLoading] = useState(true)
  const [country, setCountry] = useState('es')
  const erp = useContext(ErpClientContext)

  async function updateAll() {
    if (
      window.confirm('Are you sure you want to update all URLs of this page?')
    ) {
      setLoading(true)
      message.loading(
        'Parsing URLs, be patient, it may take several minutes.',
        0
      )
      try {
        const data = urls
          .filter((item) => item.url)
          .map((item) => ({
            group: item.product_group,
            url: item.url,
          }))
        const { ok, ko } = await erp.upsertPriceComparator(data, country)
        await init()
        message.destroy()
        message.success(`${ok.length} URLs updated successfully`)

        if (ko.length) {
          message.warning(
            ko
              .map(
                (a) =>
                  `${ko.length} URLs with an error. Error (${a[1]}) updating this URL: ${a[0]}`
              )
              .join(', \n')
          )
        }
      } catch (e) {
        message.destroy()
        message.error(`There was an error updating the data: ${e.message}`)
      } finally {
        setLoading(false)
      }
    }
  }

  async function addURL(group = prod) {
    const url = window.prompt(`Add competence URL of ${group}:`)

    if (!url) return

    message.loading('Parsing URL', 0)
    setLoading(true)

    try {
      const { ok, ko } = await erp.upsertPriceComparator(
        [{ url, group }],
        country
      )
      message.destroy()
      if (ok.length) {
        message.success(`${ok.length} URL added successfully`)
        await init()
      } else
        message.error(
          `There was an error adding the URL: ${JSON.stringify(ko)}`
        )
    } catch (e) {
      message.destroy()
      message.error(`There was an error adding the URL: ${e.message}`)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    init()
  }, [country, page, prod])
  async function init() {
    setLoading(true)
    const [res, rest] = await erp.getPriceComparator(prod, country, page)
    setUrls(res)
    setRest(rest)
    setLoading(false)
  }

  return (
    <div>
      <Affix>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 20,
            gap: 10,
            padding: 10,
            backgroundColor: 'white',
          }}
        >
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <ProductSelector
              style={{ overflow: 'hidden' }}
              products={prod ? [prod] : undefined}
              onChange={(prods) => setProd(prods[prods.length - 1])}
              width={350}
              placeholder={
                <>
                  <FileSearchOutlined /> Select a product
                </>
              }
            />
            <Select
              style={{ minWidth: 120 }}
              defaultValue={country}
              onChange={setCountry}
            >
              {COUNTRIES.map((c) => (
                <Select.Option value={c}>{ALL_COUNTRIES[c]}</Select.Option>
              ))}
            </Select>

            <Button danger onClick={updateAll}>
              Update all URLs of this page <RedoOutlined />
            </Button>
          </div>
        </div>
      </Affix>
      {loading ? (
        <Loading />
      ) : (
        <PriceComparatorTable
          data={urls}
          rest={rest}
          country={country}
          page={page}
          onUpdatePage={setPage}
          onAdd={addURL}
        />
      )}
    </div>
  )
}
